export default {"src":"/_next/static/media/eu-funded-logo.1ad4ceed.svg","height":44,"width":210,"blurWidth":0,"blurHeight":0};